<script setup>
import { ref, computed } from 'vue';
import FormSwitch from '@/components/Atoms/FormSwitch.vue'
import ButtonCopyToClipboard from '@/components/Moleculas/ButtonCopyToClipboard.vue'
import FormText from '@/components/Atoms/FormText.vue'

const responsive = defineModel('responsive', { type: Boolean, default: true })

const props = defineProps({
  url: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  // Anti-Piracy (DRM) protection requires the player iframe to be granted the
  // `encrypted-media` permission so EME/DRM playback can initialize.
  encryptedMedia: { type: Boolean, default: false },
});

const allowAttr = computed(() =>
  props.encryptedMedia ? 'autoplay; encrypted-media' : 'autoplay'
)

const iFrameCode = computed(() => {
  if (!props.url) return ''
  if (responsive.value) {
    return `<iframe src="${props.url}" width="100%" style="aspect-ratio: 16/9; min-height: 340px;" frameborder="0" scrolling="no" allow="${allowAttr.value}" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
  }
  return `<iframe src="${props.url}" width="590" height="431" frameborder="0" scrolling="no" allow="${allowAttr.value}" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>`
})

</script>

<template>
  <div class="flex items-center justify-between gap-x-2 !mb-2">
    <h3 class="text-surface-text-1 text-tiny font-medium mb-2">Embed Code</h3>
    <FormSwitch v-model="responsive" labelPosition="left" label="Responsive" />
  </div>
  <div class="relative">
    <div class="bg-surface-3 w-full !rounded-md text-tiny leading-4 block overflow-hidden break-all text-tiny !pr-12 !pl-2 !py-2">
      {{ iFrameCode }}
    </div>
    <ButtonCopyToClipboard outline isIcon class="absolute right-2 top-2" :disabled="disabled" :text="iFrameCode" />
  </div>
</template>

<style scoped></style>